
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
    name: 'PlatformTable',
    components: {
    }
})
export default class extends Vue {
    @Prop({ required: true }) private platforms!: object[]
    @Prop({ required: true }) private newsId!: string
    @Prop({ required: undefined }) private mediaType!: any

    private onGoComments(id: any, commentCount: number) {
        if (commentCount === 0) {
            this.$message({ type: 'warning', message: '暂无评论数据' })
            return
        }
        let url = `/news/${this.newsId}/comments?platformId=${id}`
        if (this.mediaType) {
            url += '&mtype=${this.mediaType}'
        }
        window.open(url)
    }
}
